module.exports = __webpack_public_path__ + "img/are.98006d47.png";